import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnderReviewTracker = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0.75 0) scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.22222 7.3H3.88889M5.33333 10.1H3.88889M9.66667 4.5H3.88889M12.5556 6.95V4.36C12.5556 3.18389 12.5556 2.59583 12.3194 2.14662C12.1117 1.75148 11.7802 1.43022 11.3725 1.22889C10.9091 1 10.3023 1 9.08889 1H4.46667C3.25322 1 2.6465 1 2.18302 1.22889C1.77534 1.43022 1.44388 1.75148 1.23615 2.14662C1 2.59583 1 3.18389 1 4.36V11.64C1 12.8161 1 13.4042 1.23615 13.8534C1.44388 14.2485 1.77534 14.5698 2.18302 14.7711C2.6465 15 3.25322 15 4.46667 15H6.41667M14 15L12.9167 13.95M13.6389 12.2C13.6389 13.5531 12.5072 14.65 11.1111 14.65C9.71506 14.65 8.58333 13.5531 8.58333 12.2C8.58333 10.8469 9.71506 9.75 11.1111 9.75C12.5072 9.75 13.6389 10.8469 13.6389 12.2Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgUnderReviewTracker);
export default ForwardRef;
